var _context, _context2, _context3;
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js/instance/bind";
// 防止被应用复写console
var myconsole = {
  log: function log() {},
  warn: function warn() {},
  error: function error() {}
};
if (typeof window !== 'undefined' && window.console) {
  myconsole = window.console;
}
if (typeof document !== 'undefined' && document.body) {
  var iframe = document.createElement('iframe');
  if (iframe && iframe.contentWindow && iframe.contentWindow.console) {
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    myconsole = iframe.contentWindow.console;
  }
}
var myLog = _bindInstanceProperty(_context = myconsole.log).call(_context, myconsole);
var myWarn = _bindInstanceProperty(_context2 = myconsole.warn).call(_context2, myconsole);
var myError = _bindInstanceProperty(_context3 = myconsole.error).call(_context3, myconsole);
var style = 'color:#fff;font-weight:bold;border-radius:5px;background:#67c23a;';
var styleError = "".concat(style, "background-color:red;");
var styleWarn = "".concat(style, "background-color:orange;");
function log() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return myLog("%c Yach-jssdk log: ", style, args);
}
function error() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return myWarn("%c Yach-jssdk log: ", styleError, args);
}
function warn() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return myError("%c Yach-jssdk log: ", styleWarn, args);
}
export { log, error, warn };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/utils/console.js
// module id = null
// module chunks = 